import { global } from "../../constants";

export const data = {
  banner: {
    base: "Servicios",
    background: global.banner + "4k.jpg",
    title: "Seguros",
    crumb: "Seguros",
  },
  icon: "fa-solid fa-shield-halved",
  shortDescription:
    "Determinación y colocación de coberturas y fianzas necesarias para proteger activos, operaciones logísticas y el bienestar del personal, con soluciones a medida para el sector marítimo y comercio exterior.",
  title: "Seguros",
  features: {
    title: "Seguros",
    deliverables: "Entregables",
    reqDocuments: "Documentos Requeridos",
    subtitle:
      "Coberturas para buques, carga, contenedores, garantías contractuales y programas personales/corporativos adaptados a operaciones marítimas y de comercio exterior.",
    description: `Diseñamos y colocamos programas de seguros patrimoniales (H&M, P&I, responsabilidad civil, carga y contenedores) y personales (salud, vida, viaje, incapacidad), además de fianzas y fideicomisos a la medida. Nuestro enfoque integra evaluación de riesgo, contratación, emisión y gestión de siniestros para minimizar exposición financiera y asegurar continuidad operativa.`,
    viewDetail: "Ver Detalles",
    feats: [
      {
        key: "hull_machinery",
        title: "Casco y Maquinaria — HULL & MACHINERY (H&M)",
        summary:
          "Cobertura para casco, maquinaria y equipos a bordo, incluyendo daños por peritación, colisión y riesgos marítimos habituales.",
        details:
          "Programa de H&M diseñado para embarcaciones comerciales, pesqueras o auxiliares: evaluación de suma asegurada, exclusiones, franquicias y cláusulas específicas para navegación internacional. Incluye asesoría en cláusulas de seguro, valoración de averías y coordinación con ajustadores marinos.",
        deliverables: [
          "Propuesta de Póliza H&M (condiciones y primas)",
          "Análisis de sumas aseguradas y recomendaciones",
          "Procedimiento para declaración y gestión de siniestros"
        ],
        requiredDocs: [
          "Ficha técnica del buque (eslora, año, bandera)",
          "Historial de mantenimiento y siniestros previos",
          "Certificados de seguridad y documentación registral"
        ],
        icon: "fa-solid fa-ship",
        image: global.services + "insurance/1.webp",
      },
      {
        key: "pandi",
        title: "P&I — Protection & Indemnity",
        summary:
          "Cobertura de responsabilidad civil para armadores y operadores: demandas por daños a terceros, contaminación, responsabilidad por tripulación y reclamaciones por carga.",
        details:
          "Asesoramos en admisión a clubs P&I o esquemas equivalentes, establecimiento de retenciones y coordinación en reclamaciones. Definimos alcance frente a contaminación, paso por esclusas/puertos y responsabilidad por daños a carga o terceros.",
        deliverables: [
          "Evaluación de necesidades P&I",
          "Gestión de adhesión/renovación y carta de cobertura",
          "Protocolo de manejo de reclamaciones P&I"
        ],
        requiredDocs: [
          "Detalles de tonelaje y operaciones",
          "Historial de reclamaciones",
          "Políticas previas y certificados P&I si los hubiere"
        ],
        icon: "fa-solid fa-hand-holding-water",
        image: global.services + "insurance/2.webp",
      },
      {
        key: "responsabilidad_civil",
        title: "Responsabilidad Civil y Riesgos Especiales",
        summary:
          "Coberturas de responsabilidad civil general y limitadas para operaciones portuarias, logística y actividades conexas; inclusión de riesgos especiales según la operación.",
        details:
          "Diseñamos pólizas de responsabilidad civil para empresa (incluye locación de servicios, agentes de aduana, almacenes generales de depósito y operadores logísticos). Evaluamos necesidades de cobertura para daños a terceros, contaminación, responsabilidad profesional y riesgos especiales (actos maliciosos, robo, riesgos políticos si aplica).",
        deliverables: [
          "Propuesta de póliza de RC con límites y exclusiones",
          "Análisis de brechas de cobertura",
          "Cláusulas recomendadas para contratos con terceros"
        ],
        requiredDocs: [
          "Descripción de actividades y operaciones",
          "Contratos con clientes/proveedores",
          "Historial de siniestros y contingencias"
        ],
        icon: "fa-solid fa-gavel",
        image: global.services + "insurance/3.webp",
      },
      {
        key: "carga_multimodal",
        title: "Cobertura de Carga — Marítima, Terrestre y Aérea",
        summary:
          "Pólizas para proteger mercancías en todas las etapas: transporte marítimo, terrestre y aéreo (todo riesgo / riesgo nombrado).",
        details:
          "Diseñamos programas de cargo para importaciones y exportaciones, incluyendo transporte multimodal, cobertura por pérdida, daño, robo y contingencias logísticas. Se contemplan cláusulas de consolidación, transbordo y almacenamiento temporal en depósitos.",
        deliverables: [
          "Condiciones de póliza cargo para cada modal",
          "Tabla de primas estimadas por tipo de mercancía",
          "Procedimiento para emisión de póliza y endosos"
        ],
        requiredDocs: [
          "Lista de mercancías y valor comercial",
          "Información de rutas y operadores",
          "Documentos de embarque (BL, AWB, guías)"
        ],
        icon: "fa-solid fa-boxes-stacked",
        image: global.services + "insurance/4.webp",
      },
      {
        key: "contenedores",
        title: "Contenedores — En Tránsito y en Patio de Puerto",
        summary:
          "Cobertura específica para contenedores mientras están en tránsito o almacenados en patios/terminales portuarias, incluyendo pérdida, daño y vandalismo.",
        details:
          "Ofrecemos pólizas y cláusulas específicas para contenedores llenos o vacíos, con extensión para daños por manipulación, almacenamiento en patios y cobertura de responsabilidad hacia terceros. Incluye opciones para seguros por unidad y por flota, así como ajustes según periodo en patio.",
        deliverables: [
          "Propuesta de seguro por contenedor (unidad/flota)",
          "Endosos para cobertura en patio y tránsito",
          "Checklist para declaración y documentación"
        ],
        requiredDocs: [
          "Listado de contenedores y estado",
          "Contratos con terminales y operadores",
          "Historial de pérdidas/daños"
        ],
        icon: "fa-solid fa-box",
        image: global.services + "insurance/5.webp",
      },
      {
        key: "fianzas_garantias",
        title:
          "Fianzas y Garantías — Mantenimiento de Oferta, Fiel Cumplimiento y Anticipo",
        summary:
          "Emisión y gestión de fianzas para licitaciones, contratos operativos y obligaciones aduaneras; garantías para agentes aduanales, almacenes y proveedores.",
        details:
          "Gestionamos garantías bancarias y fianzas para mantenimiento de oferta, fiel cumplimiento, anticipo laboral, admisión temporal y multas. Asesoramos sobre el tipo de fianza más adecuado, requisitos de emisión, plazos y gestión de reclamaciones contra la fianza.",
        deliverables: [
          "Propuesta de fianza/garantía según necesidad",
          "Apoyo en documentación para emisión",
          "Seguimiento y gestión de la fianza hasta vencimiento"
        ],
        requiredDocs: [
          "Pliego de condiciones o contrato de licitación",
          "Documentación financiera del solicitante",
          "Especificaciones del monto y periodo de garantía"
        ],
        icon: "fa-solid fa-file-shield",
        image: global.services + "insurance/6.webp",
      },
      {
        key: "fideicomiso",
        title: "Fideicomiso a la medida del cliente",
        summary:
          "Estructura fiduciaria para administración de fondos, garantías y seguridad patrimonial ligada a operaciones de comercio exterior o proyectos específicos.",
        details:
          "Diseñamos fideicomisos para asegurar obligaciones contractuales, gestionar fondos de garantía, administrar recursos de proyectos o servir como mecanismo de escrow en operaciones de compraventa de activos. Incluye redacción de escritura fiduciaria, selección de fiduciario y parametrización de reglas de liberación de fondos.",
        deliverables: [
          "Propuesta de esquema fiduciario",
          "Borrador de escritura de fideicomiso",
          "Guía operativa para el fiduciario y beneficiarios"
        ],
        requiredDocs: [
          "Finalidad y monto del fideicomiso",
          "Datos de las partes y beneficiarios",
          "Documentación legal de los activos a fiduciariar"
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "insurance/7.webp",
      },
      {
        key: "seguros_personales",
        title: "Seguros Personales y Corporativos",
        summary:
          "Programas de salud, vida, asistencia en viaje y cobertura por incapacidad, diseñados para empleados y directivos en LATAM y USA.",
        details:
          "Ofrecemos pólizas individuales y colectivas: seguro de salud (planes locales y regionales), seguro de vida para América Latina y cobertura específica para USA, asistencia en viaje internacional, seguro por incapacidad temporal o permanente y soluciones para riesgos laborales y exposiciones especiales. Incluye análisis de beneficios, prima estimada y opciones de coaseguro.",
        deliverables: [
          "Propuesta de plan de beneficios (individual/corporativo)",
          "Comparativo de coberturas y primas",
          "Instrucciones para afiliación y reclamos"
        ],
        requiredDocs: [
          "Listado de empleados/beneficiarios",
          "Datos médicos básicos (según aseguradora)",
          "Necesidades específicas y alcance requerido"
        ],
        icon: "fa-solid fa-user-shield",
        image: global.services + "insurance/8.webp",
      },
      {
        key: "gestion_siniestros",
        title: "Gestión de Siniestros y Prevención",
        summary:
          "Asistencia integral en manejo de siniestros: declaración, ajuste, negociación y cierre; además de programas preventivos para reducir ocurrencia.",
        details:
          "Coordinamos la presentación de reclamos, la interacción con ajustadores y aseguradores, evaluación de peritajes y negociación de indemnizaciones. Desarrollamos programas de prevención, auditorías de riesgo y capacitaciones para disminuir frecuencia e impacto de siniestros.",
        deliverables: [
          "Protocolo de gestión de siniestros",
          "Asistencia en tramitación y seguimiento de reclamos",
          "Informe de mejora/preventiva tras siniestro"
        ],
        requiredDocs: [
          "Reportes e incidencias del siniestro",
          "Documentación contractual y pólizas",
          "Peritajes y evidencias fotográficas"
        ],
        icon: "fa-solid fa-file-medical",
        image: global.services + "insurance/9.webp",
      }
    ],
  },
  ctaText: "Solicitar cotización de seguros",
  ctaLink: "/contacto?servicio=seguros-patrimoniales-personales",
};
